import { useEffect, useRef, useState } from "react";

const MARGIN = { top: 24, right: 26, bottom: 32, left: 46 };
const MARGIN_MOBILE = { top: 24, right: 26, bottom: 8, left: 8 };
const CHART_HEIGHT_MOBILE = 200;
const CHART_HEIGHT_DESKTOP = 400;

export function useContainerWidth<T extends HTMLElement>(
  isMobile: boolean,
): {
  ref: React.RefObject<T | null>;
  width: number;
  isReady: boolean;
  chartHeight: number;
  margin: { top: number; right: number; bottom: number; left: number };
  innerWidth: number;
  innerHeight: number;
} {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const w = entry.contentRect.width;
      if (w > 0) setWidth(Math.floor(w));
    });
    ro.observe(el);

    return () => ro.disconnect();
  }, []);

  const chartHeight = isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT_DESKTOP;
  const margin = isMobile ? MARGIN_MOBILE : MARGIN;
  const innerWidth = Math.max(width - margin.left - margin.right, 0);
  const innerHeight = Math.max(chartHeight - margin.top - margin.bottom, 0);

  return {
    ref,
    width,
    isReady: width > 0,
    chartHeight,
    margin,
    innerWidth,
    innerHeight,
  };
}
